// extracted by mini-css-extract-plugin
export default {"ellipsis":"NTbZwSL1StugwjZ0ppXc","wrapper":"IkYEbSoged1uIEN_4SPN","amount":"At7pKHiq1irZ0asEpU1q","spin":"XauAFznSF_YpH6Ech_8A"};